import ComingSimpleContainer from "../../Componant/ComingSoon/ComingSimple";

const ComingSimple = () => {
  return (
    <div className="page-wrapper compact-wrapper">
      <ComingSimpleContainer />
    </div>
  );
};

export default ComingSimple;
